export default __webpack_public_path__ + "static/media/Banner.537ba852.png";